/**
 * Created by vladislav on 3/4/2024
 */

const GameManager = function () {
    cleverapps.EventEmitter.call(this);

    connector.platform.on("pause", this.pause.bind(this));
    connector.platform.on("resume", this.resume.bind(this));
};

GameManager.prototype = Object.create(cleverapps.EventEmitter.prototype);
GameManager.prototype.constructor = GameManager;

GameManager.prototype.pause = function () {
    if (cc.game.isPaused() || cleverapps.gameModes && cleverapps.gameModes.noGamePause) {
        return;
    }

    if (connector.platform.oneOf(connector.INSTANT) && connector.info.os === connector.OS_IOS && connector.info.isInApp) {
        return;
    }

    console.log("pause game");

    cc.game.pause();

    if (cleverapps.audio) {
        cleverapps.audio.pause();
    }

    this.trigger("pause");
};

GameManager.prototype.resume = function () {
    cleverapps.audio && cleverapps.audio.resumeAudioContext();

    if (!cc.game.isPaused() || cleverapps.gameModes && cleverapps.gameModes.noGamePause) {
        return;
    }

    console.log("resume game");

    cc.game.resume();

    if (cleverapps.audio) {
        cleverapps.audio.resume();
    }

    this.trigger("resume");
};